import JsonResponse from "csi/comm/JsonResponse";
import PostRequest from "csi/comm/PostRequest";
import AggregateController from "csi/heading/AggregateController";
import locale from "csi/locale";
import csi from "csi/main";
import MessageDialog from "csi/widget/MessageDialog";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const SelectTheme = declare(AggregateController, {
	/**
	 * According to the service response we set and build the warning message
	 */
	process() {
		const { newValue, oldValue } = this;

		if (xml.isValidURL(oldValue as string) && (newValue != oldValue)) {
			// this function is used to call the service to validate the links with theme and style
			// and show the warning message according to the validation rules.
			this.setProgress();

			const dfd = new PostRequest("Specification", "ValidateThemeStyleDS")
				.addParameter(xml.PROP_URL_PARENT, this.m_urlNode)
				.post();

			this.when(dfd, (response: JsonResponse) => {
				const res = response.getReturnValue() ? "RemoveThemeFromStyle_Confirm" : "RemoveThemeFromStyleNoLinked_Confirm";

				this.confirmAction({
					materialIcon: MessageDialog.ICON_WARNING,
					title: locale.resource("WARNING"),
					buttons: [MessageDialog.BUTTON_YES, MessageDialog.BUTTON_CANCEL],
					message: locale.typeAction("Style", res),
					onResponse: (key: string) => {
						if (key == MessageDialog.BUTTON_YES) {
							AggregateController.prototype.process.call(this);
						} else {
							this.postProcess();
						}
					},
				});
			});
		} else {
			AggregateController.prototype.process.call(this);
		}
	},
});

export = SelectTheme;
